import { create } from 'zustand'

const useProductStore = create((set) => ({
  images: [],
  setImages: (images) => set({ images }),
  selectedImage: null,
  setSelectedImage: (image) => set({ selectedImage: image }),
  factoryOptions: [],
  setFactories: (factoryOptions) => set({ factoryOptions }),
  categories: [],
  setCategories: (categories) => set({ categories }),
  reportCategories: [],
  setReportCategories: (reportCategories) => set({ reportCategories }),
  subcategoryOptions: [],
  setSubcategoryOptions: (subcategoryOptions) => set({ subcategoryOptions }),
  colorOptions: [],
  setColorOptions: (colorOptions) => set({ colorOptions }),
  addCategory: (category) => set((state) => ({
    categories: [...state.categories, category]
  })),
  addReportCategory: (category) => set((state) => ({
    reportCategories: [...state.reportCategories, category]
  })),
  addSubcategory: (subcategory) => set((state) => ({
    subcategoryOptions: [...state.subcategoryOptions, subcategory]
  })),
  addColor: (color) => set((state) => ({
    colorOptions: [...state.colorOptions, color]
  })),
  addFactory: (factory) => set((state) => ({
    factoryOptions: [...state.factoryOptions, factory]
  })),
  productName: '',
  setProductName: (name) => set({ productName: name }),
  productNameExists: false,
  setProductNameExists: (exists) => set({ productNameExists: exists }),
  selectedCategory: null,

  setSelectedCategory: (category) => set({ selectedCategory: category }),
  selectedFactory: null,
  setSelectedFactory: (factory) => set({ selectedFactory: factory }),
  selectedReportCategory: null,
  setselectedReportCategory: (category) => set({ selectedReportCategory: category }),
  subCategory: '',
  setSubCategory: (subCategory) => set({ subCategory }),
  selectedSubcategory: null,
  setSelectedSubcategory: (subcategory) => set({ selectedSubcategory: subcategory }),
  reset: () => set({
    images: [],
    selectedImage: null,
    productName: '',
    productNameExists: false,
    selectedCategory: null,
    selectedFactory: null,
    selectedReportCategory: null,
    subCategory: '',
    selectedSubcategory: null,
  })
  
}))

export default useProductStore
